import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-label"]

import { computed } from 'vue';
import { ServiceStatusType } from '../../types';
import { Icon } from '../../Atoms';


export default /*@__PURE__*/_defineComponent({
  __name: 'FilterStatusKeyButton',
  props: {
    filters: {},
    onClick: { type: Function }
  },
  setup(__props: any) {

const props = __props;

const showAllFilters = computed(() => !props.filters || props.filters.length === 0);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "filterStatusKeyButton",
    "aria-label": _ctx.$t('Status key button aria label'),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
  }, [
    _createVNode(_unref(Icon), {
      class: "filterIcon",
      "icon-name": "filter"
    }),
    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "filterText" }, "Filter routes: ", -1)),
    (showAllFilters.value || _ctx.filters?.includes(_unref(ServiceStatusType).Normal))
      ? (_openBlock(), _createBlock(_unref(Icon), {
          key: 0,
          "icon-name": "statusNormal"
        }))
      : _createCommentVNode("", true),
    (showAllFilters.value || _ctx.filters?.includes(_unref(ServiceStatusType).AtRisk))
      ? (_openBlock(), _createBlock(_unref(Icon), {
          key: 1,
          "icon-name": "statusAtRisk"
        }))
      : _createCommentVNode("", true),
    (showAllFilters.value || _ctx.filters?.includes(_unref(ServiceStatusType).Disruption))
      ? (_openBlock(), _createBlock(_unref(Icon), {
          key: 2,
          "icon-name": "statusDelayed"
        }))
      : _createCommentVNode("", true),
    (showAllFilters.value || _ctx.filters?.includes(_unref(ServiceStatusType).Cancelled))
      ? (_openBlock(), _createBlock(_unref(Icon), {
          key: 3,
          "icon-name": "statusCancelled"
        }))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})